/**
 * Trade Codes View
 * PRODCOM tab is permission-gated via data permissions.
 */

import React from 'react';
import TradeCodesView from '../features/hsGroupedHSCode/TradeCodesView';
import { useAuth } from './auth/AuthProvider';

const PermissionAwareTradeCodesView: React.FC = () => {
  const { user, permissions } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.role === 'superuser';
  const hasProdcomViewPermission = (permissions?.dataPermissions || []).some((permission) => {
    const level = String(permission?.permission_level || '').toLowerCase();
    const hasReadLevel = level === 'read' || level === 'write' || level === 'admin';
    return (
      String(permission?.data_type || '') === 'prodcom_view' &&
      String(permission?.data_identifier || '') === 'enabled' &&
      permission?.is_active === true &&
      hasReadLevel
    );
  });

  return <TradeCodesView canAccessProdcom={Boolean(isAdmin || hasProdcomViewPermission)} />;
};

export default PermissionAwareTradeCodesView;
